import { render, staticRenderFns } from "./MyOnlineClassesIndex.vue?vue&type=template&id=7527b4ce&scoped=true&"
import script from "./MyOnlineClassesIndex.vue?vue&type=script&lang=js&"
export * from "./MyOnlineClassesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7527b4ce",
  null
  
)

export default component.exports